                    import * as THREE from 'three';
                    import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';
                    import { OrbitControls } from 'three/addons/controls/OrbitControls.js';
                    import { FontLoader } from 'three/addons/loaders/FontLoader.js';
                    import { TextGeometry } from 'three/addons/geometries/TextGeometry.js';
                    import { RoomEnvironment } from 'three/addons/environments/RoomEnvironment.js';

                    (function () {
                      const cfg = window.namechainBuilderConfig || {};
                      const blockId = cfg.blockId;
                      const sectionId = cfg.sectionId;
                      const chainGlbUrl = cfg.chainGlbUrl || '';
                      const fontUrl = cfg.fontUrl || '';
                      const charms = cfg.charms || [];
                      const chainProductId = cfg.chainProductId;
                      const chainVariantIdDefault = cfg.chainVariantIdDefault;
                      const chainPriceCents = cfg.chainPriceCents;

                      const MAX_CHARMS = 10;
                      const CHARM_SIZE = 1.12;
                      // V-layout anchors flanking nameplate. Chain comes down-from-upper-left as \, nameplate
                      // centered at (0, 1.7), chain rises up-to-upper-right as /. Left arm = slots 1-5 (innermost→outermost going up-left), right arm = 6-10 (innermost→outermost going up-right).
                      const CHARM_ANCHORS = (function () {
                        const cx = 3.7;          // half-gap around nameplate
                        const cy = 1.85;         // baseline Y at inner end of each arm
                        const dx = 0.45;         // x step per slot along arm
                        const dy = 0.7;          // y step per slot along arm
                        const xOff = 0.4;        // whole V shift along chain-local X
                        const z  = -1.5;         // depth (chain LOCAL space)
                        const out = [];
                        for (let i = 0; i < 5; i++) out.push({ x: xOff - (cx + dx * i), y: cy + dy * i, z: z }); // left \
                        for (let i = 0; i < 5; i++) out.push({ x: xOff + (cx + dx * i), y: cy + dy * i, z: z }); // right /
                        return out;
                      })();
                      const ANCHOR_DEBUG = new URLSearchParams(location.search).has('nc-anchor');

                      const triggerBtn = document.getElementById('nc-addon-trigger-' + blockId);
                      const hintEl = document.getElementById('nc-addon-hint-' + blockId);
                      const modal = document.getElementById('nc-addon-modal-' + blockId);
                      const canvas = document.getElementById('nc-modal-canvas-' + blockId);
                      const loaderEl = document.getElementById('nc-modal-loader-' + blockId);
                      const galleryEl = document.getElementById('nc-modal-gallery-' + blockId);
                      const trayEl = document.getElementById('nc-modal-tray-' + blockId);
                      const counterEl = document.getElementById('nc-modal-counter-' + blockId);
                      const totalEl = document.getElementById('nc-modal-total-' + blockId);
                      const submitBtn = document.getElementById('nc-modal-submit-' + blockId);
                      const nameInput = document.getElementById('your-name-for-the-pendant');
                      const productForm = document.getElementById('product-form-' + sectionId);

                      if (!modal || !canvas) return;

                      // Relocate dialog to <body> so it escapes any transformed/contained ancestor
                      // (Shopify Dawn nests product blocks deeply; some ancestors can break dialog centering / top-layer behavior).
                      if (modal.parentElement !== document.body) document.body.appendChild(modal);

                      // --- Place button just above the add-to-cart submit in the product form ---
                      function placeTrigger() {
                        const host = document.getElementById('nc-addon-host-' + blockId);
                        if (!host || !productForm) return;
                        const submit = productForm.querySelector('[name="add"], button[type="submit"]');
                        if (submit && submit.parentElement) {
                          submit.parentElement.insertBefore(host, submit);
                        }
                      }
                      placeTrigger();

                      // --- Enable trigger when name has ≥ 2 chars (mirrors generateText() rule) ---
                      function syncTriggerState() {
                        const name = (nameInput && nameInput.value || '').trim();
                        const ok = name.length >= 2;
                        triggerBtn.disabled = !ok;
                        if (hintEl) hintEl.hidden = ok;
                      }
                      syncTriggerState();
                      if (nameInput) nameInput.addEventListener('input', syncTriggerState);

                      // --- Cart formatting helpers ---
                      function formatMoney(cents) {
                        const v = (cents / 100);
                        return '$' + v.toFixed(2);
                      }
                      function getCurrentVariantId() {
                        if (!productForm) return chainVariantIdDefault;
                        const idInput = productForm.querySelector('input[name="id"]');
                        return idInput ? Number(idInput.value) : chainVariantIdDefault;
                      }
                      function metalFromText(t) {
                        t = (t || '').toLowerCase();
                        if (t.includes('silver')) return 'silver';
                        if (t.includes('gold')) return 'gold';
                        return '';
                      }
                      // Variant pickers live in <variant-selects>/<variant-radios> OUTSIDE the
                      // form (linked via form= attr). Query by section id, not the form.
                      function getCurrentMetal() {
                        const roots = [
                          document.getElementById('variant-radios-' + sectionId),
                          document.getElementById('variant-selects-' + sectionId),
                          productForm,
                        ].filter(Boolean);
                        let txt = '';
                        roots.forEach((root) => {
                          root.querySelectorAll('input[type="radio"]:checked').forEach((el) => {
                            const m = metalFromText(el.value); if (m) txt = m;
                          });
                          root.querySelectorAll('select').forEach((s) => {
                            const m = metalFromText(s.value); if (m) txt = m;
                          });
                        });
                        if (!txt) {
                          // Fallback: selected variant id → variant options
                          const idInput = document.querySelector('#product-form-' + sectionId + ' input[name="id"], #product-form-' + sectionId + ' select[name="id"]');
                          const vid = idInput && String(idInput.value);
                          const root = document.getElementById('variant-selects-' + sectionId) || document.getElementById('variant-radios-' + sectionId);
                          const json = root && root.querySelector('script[type="application/json"]');
                          if (vid && json) {
                            try {
                              const variants = JSON.parse(json.textContent);
                              const v = variants.find((x) => String(x.id) === vid);
                              if (v) txt = metalFromText((v.title || '') + ' ' + (v.options || []).join(' '));
                            } catch (e) {}
                          }
                        }
                        return txt === 'gold' ? 'Gold' : (txt === 'silver' ? 'Silver' : '');
                      }
                      // Recolor the loaded chain mesh to match the selected Shopify metal.
                      function recolorChain(metal) {
                        if (!chainModel) return;
                        const isSilver = metal === 'silver';
                        chainModel.traverse((c) => {
                          if (!c.isMesh || !c.material) return;
                          c.material.color = new THREE.Color(isSilver ? 0xdadadc : 0xd4af37);
                          c.material.metalness = 0.96;
                          c.material.roughness = isSilver ? 0.26 : 0.47;
                          c.material.envMapIntensity = 0.8;
                          c.material.needsUpdate = true;
                        });
                      }

                      // --- Three.js scene (lazy-init when modal opens) ---
                      let inited = false;
                      let renderer, scene, camera, controls, chainModel, charmGroup, textMesh, pinyonFont, refBox3;
                      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
                      function isLongEnd(n) { return ['l','d','b','f'].includes(n[n.length-1]); }
                      function isHalfLongEnd(n) { return n[n.length-1] === 't'; }
                      let goldMat, silverMat, currentMetal = 'gold';
                      let rafId = null;

                      function initScene() {
                        if (inited) return;
                        inited = true;
                        const size = (typeof measureCanvas === 'function' ? measureCanvas() : (canvas.clientWidth || 480));
                        const isMobile = window.matchMedia('(max-width: 749px)').matches;
                        renderer = new THREE.WebGLRenderer({
                          canvas,
                          antialias: true,
                          alpha: false,
                          powerPreference: isMobile ? 'low-power' : 'high-performance',
                          precision: 'highp',
                          preserveDrawingBuffer: true,
                        });
                        renderer.setSize(size, size, false);
                        renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
                        renderer.outputColorSpace = THREE.SRGBColorSpace;
                        renderer.useLegacyLights = true;
                        renderer.toneMapping = THREE.ACESFilmicToneMapping;
                        renderer.toneMappingExposure = 0.92;
                        renderer.shadowMap.enabled = !isMobile;
                        renderer.shadowMap.type = THREE.PCFSoftShadowMap;

                        scene = new THREE.Scene();
                        scene.background = new THREE.Color(0xffffff);
                        // match on-page render: PMREM room env so gold reflects bright room
                        const pmrem = new THREE.PMREMGenerator(renderer);
                        scene.environment = pmrem.fromScene(new RoomEnvironment(), 0.04).texture;
                        scene.environmentIntensity = 1.0;

                        camera = new THREE.PerspectiveCamera(25, 1, 0.1, 10000);
                        camera.position.set(0, 5, 35);
                        scene.add(camera);

                        controls = new OrbitControls(camera, canvas);
                        controls.target.set(0, 5, 0);
                        controls.enableDamping = true;
                        controls.enablePan = false;
                        controls.minDistance = 10;
                        controls.maxDistance = 30;
                        controls.enabled = true;
                        scene.add(new THREE.AmbientLight(0xffffff, 0.3));
                        scene.add(new THREE.HemisphereLight(0xffffff, 0xdddddd, 0.24));
                        const k = new THREE.PointLight(0xffffff, 1.3);
                        k.position.set(4.3, -10, 25);
                        k.castShadow = !isMobile;
                        if (k.castShadow) { k.shadow.mapSize.set(2048, 2048); k.shadow.bias = -0.0008; k.shadow.normalBias = 0.05; k.shadow.radius = 6; }
                        scene.add(k);
                        const f = new THREE.PointLight(0xffffff, 1.1); f.position.set(20, 10, -25); scene.add(f);
                        const b = new THREE.PointLight(0xffffff, 1.1); b.position.set(-20, 10, -25); scene.add(b);
                        const top = new THREE.PointLight(0xfff4e0, 0.32); top.position.set(0, 25, 10); scene.add(top);

                        goldMat = new THREE.MeshStandardMaterial({ metalness: 0.96, roughness: 0.47, envMapIntensity: 0.8, color: new THREE.Color(0xd4af37) });
                        silverMat = new THREE.MeshStandardMaterial({ metalness: 0.96, roughness: 0.26, envMapIntensity: 0.8, color: new THREE.Color(0xdadadc) });

                        // Invisible reference box — text scaling anchor, identical to product-section viewer
                        const refBox = new THREE.Mesh(new THREE.BoxGeometry(5.7, 2), new THREE.MeshStandardMaterial({ transparent: true, opacity: 0 }));
                        refBox.position.set(-0.35, 1.7, 1.7);
                        scene.add(refBox);
                        refBox3 = new THREE.Box3().setFromObject(refBox);

                        let roFrame = 0;
                        const ro = new ResizeObserver(() => {
                          if (roFrame) return;
                          roFrame = requestAnimationFrame(() => {
                            roFrame = 0;
                            const w = measureCanvas();
                            if (w > 0) renderer.setSize(w, w, false);
                          });
                        });
                        ro.observe(canvas);

                        const glTFLoader = new GLTFLoader();
                        glTFLoader.load(chainGlbUrl, (gltf) => {
                          chainModel = gltf.scene;
                          chainModel.traverse((child) => {
                            child.castShadow = false;
                            child.receiveShadow = false;
                            if (child.isMesh) {
                              child.material.color = new THREE.Color(0xd4af37);
                              child.material.metalness = 0.96;
                              child.material.roughness = 0.47;
                              child.material.envMapIntensity = 0.8;
                              child.material.needsUpdate = true;
                            }
                          });
                          chainModel.rotateY(-Math.PI / 2 - Math.PI / 4.2);
                          scene.add(chainModel);
                          // Match chain to currently selected Shopify metal
                          const m0 = getCurrentMetal();
                          if (m0) currentMetal = m0.toLowerCase();
                          recolorChain(currentMetal);

                          charmGroup = new THREE.Group();
                          charmGroup.rotation.y = (typeof self._ncGroupYaw === 'number') ? self._ncGroupYaw : CHARM_GROUP_YAW_DEFAULT;
                          chainModel.add(charmGroup);

                          // === Anchor capture tool (?anchor=1) — drag markers in chain LOCAL space, export JSON ===
                          if (new URLSearchParams(location.search).has('anchor')) {
                            initAnchorCapture(chainModel);
                          }
                          if (ANCHOR_DEBUG) {
                            drawAnchorMarkers();
                            initVTuner();
                          }

                          if (!fontUrl) { loaderEl.style.display = 'none'; rebuildCharms(); return; }
                          new FontLoader().load(fontUrl, (font) => {
                            pinyonFont = font;
                            loaderEl.style.display = 'none';
                            updateNameText();
                            rebuildCharms();
                          }, undefined, () => { loaderEl.style.display = 'none'; rebuildCharms(); });
                        }, undefined, () => { loaderEl.textContent = 'Failed to load chain.'; });

                        function tick() {
                          controls.update();
                          renderer.render(scene, camera);
                          rafId = requestAnimationFrame(tick);
                        }
                        tick();
                      }

                      function initAnchorCapture(chainModel) {
                        const ANCHOR_COUNT = CHARM_ANCHORS.length;
                        const LS_KEY = 'namechain-anchors-v1';
                        const chainScale = chainModel.scale.x || 1;
                        const defaultLocal = (i) => CHARM_ANCHORS[i] || { x: 0, y: 0, z: 0 };
                        let saved = null;
                        try { saved = JSON.parse(localStorage.getItem(LS_KEY) || 'null'); } catch (e) {}

                        function makeLabel(text) {
                          const c = document.createElement('canvas');
                          c.width = 64; c.height = 64;
                          const ctx = c.getContext('2d');
                          ctx.fillStyle = 'rgba(0,0,0,0.7)';
                          ctx.beginPath(); ctx.arc(32, 32, 28, 0, Math.PI * 2); ctx.fill();
                          ctx.fillStyle = '#fff';
                          ctx.font = 'bold 32px sans-serif';
                          ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
                          ctx.fillText(text, 32, 34);
                          const tex = new THREE.CanvasTexture(c);
                          tex.colorSpace = THREE.SRGBColorSpace;
                          const sp = new THREE.Sprite(new THREE.SpriteMaterial({ map: tex, depthTest: false, transparent: true }));
                          const s = 0.6 / chainScale;
                          sp.scale.set(s, s, 1);
                          sp.position.y = 0.45 / chainScale;
                          sp.renderOrder = 1000;
                          return sp;
                        }

                        const markerGeo = new THREE.SphereGeometry(0.2 / chainScale, 16, 16);
                        const anchors = [];
                        function makeMarker(i) {
                          const mat = new THREE.MeshBasicMaterial({ color: 0xff3355, depthTest: false, transparent: true, opacity: 0.92 });
                          const mesh = new THREE.Mesh(markerGeo, mat);
                          mesh.renderOrder = 999;
                          mesh.userData.anchorIndex = i;
                          mesh.add(makeLabel(String(i + 1)));
                          chainModel.add(mesh);
                          return mesh;
                        }
                        for (let i = 0; i < ANCHOR_COUNT; i++) {
                          const mesh = makeMarker(i);
                          const p = (saved && saved[i] && Number.isFinite(saved[i].x)) ? saved[i] : defaultLocal(i);
                          mesh.position.set(p.x, p.y, p.z);
                          anchors.push(mesh);
                        }

                        let selectedIdx = 0;
                        function setSelected(idx) {
                          selectedIdx = idx;
                          anchors.forEach((m, k) => {
                            m.material.color.set(k === idx ? 0x33ff66 : 0xff3355);
                            m.scale.setScalar(k === idx ? 1.8 : 1);
                          });
                          syncInputs();
                        }

                        const viewerEl = canvas.parentElement;
                        if (getComputedStyle(viewerEl).position === 'static') viewerEl.style.position = 'relative';
                        const panel = document.createElement('div');
                        panel.style.cssText = 'position:absolute;top:8px;right:8px;background:rgba(20,20,20,0.88);color:#fff;font:12px/1.3 system-ui,sans-serif;padding:8px;border-radius:6px;z-index:10;display:flex;flex-direction:column;gap:6px;width:200px;box-shadow:0 2px 8px rgba(0,0,0,0.3);';
                        panel.innerHTML =
                          '<div style="font-weight:600;">Anchor capture</div>' +
                          '<select data-r="sel" style="width:100%;padding:3px;background:#222;color:#fff;border:1px solid #444;">' +
                            anchors.map((_, i) => '<option value="' + i + '">Anchor ' + (i + 1) + '</option>').join('') +
                          '</select>' +
                          '<label style="display:flex;align-items:center;gap:4px;">X<input data-r="x" type="number" step="0.01" style="flex:1;min-width:0;background:#222;color:#fff;border:1px solid #444;padding:2px;"></label>' +
                          '<label style="display:flex;align-items:center;gap:4px;">Y<input data-r="y" type="number" step="0.01" style="flex:1;min-width:0;background:#222;color:#fff;border:1px solid #444;padding:2px;"></label>' +
                          '<label style="display:flex;align-items:center;gap:4px;">Z<input data-r="z" type="number" step="0.01" style="flex:1;min-width:0;background:#222;color:#fff;border:1px solid #444;padding:2px;"></label>' +
                          '<div style="display:flex;gap:4px;">' +
                            '<button data-r="copy" type="button" style="flex:1;padding:4px;background:#2a5;color:#fff;border:0;border-radius:3px;cursor:pointer;">Copy</button>' +
                            '<button data-r="dl" type="button" style="flex:1;padding:4px;background:#25a;color:#fff;border:0;border-radius:3px;cursor:pointer;">Save</button>' +
                            '<button data-r="reset" type="button" style="flex:1;padding:4px;background:#a52;color:#fff;border:0;border-radius:3px;cursor:pointer;">Reset</button>' +
                          '</div>' +
                          '<div style="font-size:10px;opacity:0.7;">Shift=Y only · Alt=X only</div>';
                        viewerEl.appendChild(panel);

                        const selEl = panel.querySelector('[data-r=sel]');
                        const xEl = panel.querySelector('[data-r=x]');
                        const yEl = panel.querySelector('[data-r=y]');
                        const zEl = panel.querySelector('[data-r=z]');

                        function syncInputs() {
                          const m = anchors[selectedIdx];
                          selEl.value = String(selectedIdx);
                          if (document.activeElement !== xEl) xEl.value = m.position.x.toFixed(3);
                          if (document.activeElement !== yEl) yEl.value = m.position.y.toFixed(3);
                          if (document.activeElement !== zEl) zEl.value = m.position.z.toFixed(3);
                        }
                        function exportData() {
                          return anchors.map((m) => ({ x: m.position.x, y: m.position.y, z: m.position.z }));
                        }
                        function persist() {
                          const data = exportData();
                          try { localStorage.setItem(LS_KEY, JSON.stringify(data)); } catch (e) {}
                          return data;
                        }

                        selEl.addEventListener('change', () => setSelected(parseInt(selEl.value, 10)));
                        function onInput() {
                          const m = anchors[selectedIdx];
                          const nx = parseFloat(xEl.value), ny = parseFloat(yEl.value), nz = parseFloat(zEl.value);
                          m.position.set(Number.isFinite(nx) ? nx : m.position.x, Number.isFinite(ny) ? ny : m.position.y, Number.isFinite(nz) ? nz : m.position.z);
                          persist();
                        }
                        xEl.addEventListener('input', onInput);
                        yEl.addEventListener('input', onInput);
                        zEl.addEventListener('input', onInput);

                        panel.querySelector('[data-r=copy]').addEventListener('click', () => {
                          const json = JSON.stringify(persist());
                          if (navigator.clipboard) navigator.clipboard.writeText(json).catch(() => {});
                        });
                        panel.querySelector('[data-r=dl]').addEventListener('click', () => {
                          const blob = new Blob([JSON.stringify(persist(), null, 2)], { type: 'application/json' });
                          const u = URL.createObjectURL(blob);
                          const a = document.createElement('a');
                          a.href = u; a.download = 'namechain-anchors.json';
                          document.body.appendChild(a); a.click(); a.remove();
                          URL.revokeObjectURL(u);
                        });
                        panel.querySelector('[data-r=reset]').addEventListener('click', () => {
                          anchors.forEach((m, i) => { const d = defaultLocal(i); m.position.set(d.x, d.y, d.z); });
                          persist();
                          syncInputs();
                        });

                        setSelected(0);

                        const raycaster = new THREE.Raycaster();
                        const pointer = new THREE.Vector2();
                        const dragPlane = new THREE.Plane();
                        const planeNormal = new THREE.Vector3();
                        const worldHit = new THREE.Vector3();
                        const tmpHit = new THREE.Vector3();
                        let dragging = null;
                        let dragStartLocal = null;
                        let downX = 0, downY = 0, moved = false;
                        let modKey = null;

                        function setPointer(ev) {
                          const rect = renderer.domElement.getBoundingClientRect();
                          pointer.x = ((ev.clientX - rect.left) / rect.width) * 2 - 1;
                          pointer.y = -((ev.clientY - rect.top) / rect.height) * 2 + 1;
                        }
                        function pick() {
                          raycaster.setFromCamera(pointer, camera);
                          const hits = raycaster.intersectObjects(anchors, false);
                          return hits.length ? hits[0].object : null;
                        }
                        renderer.domElement.addEventListener('pointerdown', (ev) => {
                          setPointer(ev);
                          const hit = pick();
                          if (!hit) return;
                          dragging = hit;
                          downX = ev.clientX; downY = ev.clientY; moved = false;
                          modKey = ev.shiftKey ? 'shift' : (ev.altKey ? 'alt' : null);
                          dragStartLocal = dragging.position.clone();
                          controls.enabled = false;
                          camera.getWorldDirection(planeNormal);
                          dragging.getWorldPosition(worldHit);
                          dragPlane.setFromNormalAndCoplanarPoint(planeNormal, worldHit);
                          try { renderer.domElement.setPointerCapture(ev.pointerId); } catch (e) {}
                          ev.preventDefault();
                        });
                        renderer.domElement.addEventListener('pointermove', (ev) => {
                          if (!dragging) return;
                          if (Math.hypot(ev.clientX - downX, ev.clientY - downY) > 3) moved = true;
                          setPointer(ev);
                          raycaster.setFromCamera(pointer, camera);
                          if (!raycaster.ray.intersectPlane(dragPlane, tmpHit)) return;
                          const local = chainModel.worldToLocal(tmpHit.clone());
                          if (modKey === 'shift') dragging.position.set(dragStartLocal.x, local.y, dragStartLocal.z);
                          else if (modKey === 'alt') dragging.position.set(local.x, dragStartLocal.y, dragStartLocal.z);
                          else dragging.position.copy(local);
                          if (anchors[selectedIdx] !== dragging) setSelected(dragging.userData.anchorIndex);
                          else syncInputs();
                          persist();
                        });
                        function endDrag(ev) {
                          if (!dragging) return;
                          if (!moved) setSelected(dragging.userData.anchorIndex);
                          try { renderer.domElement.releasePointerCapture(ev.pointerId); } catch (e) {}
                          dragging = null; dragStartLocal = null; moved = false; modKey = null;
                          controls.enabled = true;
                        }
                        renderer.domElement.addEventListener('pointerup', endDrag);
                        renderer.domElement.addEventListener('pointercancel', endDrag);
                      }

                      function updateNameText() {
                        if (!pinyonFont || !scene || !refBox3) return;
                        let name = (nameInput && nameInput.value || 'aaliyah').slice(0, 9);
                        if (!name) return;
                        if (textMesh) { scene.remove(textMesh); textMesh.geometry.dispose(); textMesh.material.dispose && textMesh.material.dispose(); textMesh = null; }
                        const geo = new TextGeometry(name, {
                          font: pinyonFont, size: 2,
                          height: isMobile ? 0.01 : 0.03,
                          curveSegments: isMobile ? 4 : 12,
                          bevelEnabled: !isMobile,
                          bevelThickness: 0.03, bevelSize: 0.02, bevelOffset: 0, bevelSegments: 2
                        });
                        textMesh = new THREE.Mesh(geo, currentMetal === 'gold' ? goldMat : silverMat);
                        textMesh.castShadow = !isMobile;
                        textMesh.position.z = 1.73;
                        const tb = new THREE.Box3().setFromObject(textMesh);
                        let sc = refBox3.max.x / tb.max.x * 2.35;
                        if (isLongEnd(name)) sc *= 1.1;
                        else if (isHalfLongEnd(name)) sc *= 1.05;
                        textMesh.scale.setScalar(sc);
                        textMesh.position.x = -tb.max.x / 2 * sc - 0.3 / sc + (name.length > 7 ? 0.1 : 0);
                        if (isLongEnd(name)) textMesh.position.x += sc / 3;
                        else if (isHalfLongEnd(name)) textMesh.position.x += sc / 6;
                        textMesh.position.y = 1.7;
                        scene.add(textMesh);
                      }

                      // --- Charm cache + rebuild ---
                      const gltf = new GLTFLoader();
                      const charmCache = new Map();
                      // Per-charm Y-axis rotation overrides (mirror of threejs_cube block).
                      // Values are absolute Y for that block; default there is Math.PI/2.
                      // Here we apply delta (override - default) on top of wrap's face-yaw.
                      const CHARM_Y_ROTATION_DEFAULT = Math.PI / 2;
                      const CHARM_Y_ROTATION = {
                        'big-dog-energy-charm': Math.PI,
                        'she-blooms-charm': 0,
                        'she-s-flirty-charm': -Math.PI / 2,
                        'bear-with-her-charm': -Math.PI / 2,
                      };
                      // Charms whose baked texture stays as-is for Gold; Silver = grayscale of texture.
                      const TEXTURE_GRAYSCALE_CHARMS = new Set([
                        'she-s-flirty-charm',
                        'she-s-the-one-charm',
                        'she-s-a-masterpiece-charm',
                        'pearl-of-her-love-charm',
                      ]);
                      const grayscaleTexCache = new Map();
                      function isDrawable(img) {
                        if (!img) return false;
                        if (typeof HTMLImageElement !== 'undefined' && img instanceof HTMLImageElement) return img.complete && img.naturalWidth > 0;
                        if (typeof HTMLCanvasElement !== 'undefined' && img instanceof HTMLCanvasElement) return true;
                        if (typeof ImageBitmap !== 'undefined' && img instanceof ImageBitmap) return true;
                        if (typeof OffscreenCanvas !== 'undefined' && img instanceof OffscreenCanvas) return true;
                        return false;
                      }
                      function getGrayscaleTexture(srcTex) {
                        if (!srcTex || !srcTex.image) return null;
                        const img = srcTex.image;
                        if (grayscaleTexCache.has(img)) return grayscaleTexCache.get(img);
                        if (!isDrawable(img)) { console.warn('[gray-nc] not drawable', img && img.constructor && img.constructor.name); return null; }
                        const w = img.naturalWidth || img.width || 256;
                        const h = img.naturalHeight || img.height || 256;
                        const cv = document.createElement('canvas');
                        cv.width = w; cv.height = h;
                        const ctx = cv.getContext('2d', { willReadFrequently: true });
                        try { ctx.drawImage(img, 0, 0, w, h); } catch (e) { console.warn('[gray-nc] drawImage failed', e); return null; }
                        let id;
                        try { id = ctx.getImageData(0, 0, w, h); }
                        catch (e) { console.warn('[gray-nc] getImageData failed (CORS taint?)', e); return null; }
                        const d = id.data;
                        for (let i = 0; i < d.length; i += 4) {
                          const g = 0.299 * d[i] + 0.587 * d[i+1] + 0.114 * d[i+2];
                          d[i] = d[i+1] = d[i+2] = g;
                        }
                        ctx.putImageData(id, 0, 0);
                        const t = new THREE.CanvasTexture(cv);
                        t.colorSpace = srcTex.colorSpace || THREE.SRGBColorSpace;
                        t.wrapS = srcTex.wrapS; t.wrapT = srcTex.wrapT;
                        t.minFilter = srcTex.minFilter;
                        t.magFilter = srcTex.magFilter;
                        t.flipY = srcTex.flipY;
                        t.generateMipmaps = srcTex.generateMipmaps;
                        t.anisotropy = srcTex.anisotropy;
                        t.needsUpdate = true;
                        grayscaleTexCache.set(img, t);
                        return t;
                      }
                      function applyGrayscaleMap(inst, label) {
                        let meshes = 0, mapsFound = 0, swapped = 0, noMap = 0;
                        const swap = (mat) => {
                          if (!mat) return mat;
                          if (!mat.map) { noMap++; return mat; }
                          mapsFound++;
                          const gtx = getGrayscaleTexture(mat.map);
                          if (!gtx) return mat;
                          const cloned = mat.clone();
                          cloned.map = gtx;
                          cloned.color = new THREE.Color(0xffffff);
                          cloned.needsUpdate = true;
                          swapped++;
                          return cloned;
                        };
                        inst.traverse((c) => {
                          if (!c.isMesh) return;
                          meshes++;
                          if (Array.isArray(c.material)) c.material = c.material.map(swap);
                          else c.material = swap(c.material);
                        });
                        console.log('[gray-nc]', label || '', 'meshes=' + meshes, 'mapsFound=' + mapsFound, 'swapped=' + swapped, 'noMap=' + noMap);
                      }
                      function makeCharmMat(color) {
                        if (color === 'silver') return new THREE.MeshStandardMaterial({ color: 0xe6e8ea, metalness: 0.95, roughness: 0.22 });
                        return new THREE.MeshStandardMaterial({ color: 0xffcc44, metalness: 0.9, roughness: 0.28 });
                      }
                      function hasCharmImageMap(model) {
                        let found = false;
                        model.traverse((c) => {
                          if (!c.isMesh || found) return;
                          const mats = Array.isArray(c.material) ? c.material : [c.material];
                          mats.forEach(m => { if (m && m.map) found = true; });
                        });
                        return found;
                      }
                      function colorCharm(model, color) {
                        model.traverse((c) => {
                          if (!c.isMesh) return;
                          c.material = makeCharmMat(color);
                        });
                      }
                      function loadCharm(url) {
                        if (charmCache.has(url)) return charmCache.get(url);
                        const p = new Promise((resolve, reject) => {
                          gltf.load(url, (g) => {
                            const goldenable = !hasCharmImageMap(g.scene);
                            resolve({ scene: g.scene, goldenable });
                          }, undefined, reject);
                        });
                        charmCache.set(url, p);
                        return p;
                      }
                      let buildToken = 0;
                      // Counter-rotate to cancel chain's parent rotation so charms face camera.
                      // chain rotateY = -(π/2 + π/4.2) → wrap needs +(π/2 + π/4.2)
                      const CHARM_FACE_YAW = Math.PI / 2 + Math.PI / 4.2;
                      const CHARM_GROUP_YAW_DEFAULT = -0.81;
                      async function rebuildCharms() {
                        if (!charmGroup) return;
                        if (typeof self._ncGroupYaw === 'number') charmGroup.rotation.y = self._ncGroupYaw;
                        const token = ++buildToken;
                        while (charmGroup.children.length) charmGroup.remove(charmGroup.children[0]);
                        const entries = await Promise.all(state.selection.map(s => s ? loadCharm(s.url).catch(() => null) : Promise.resolve(null)));
                        if (token !== buildToken) return;
                        entries.forEach((entry, i) => {
                          if (!entry) return;
                          const a = CHARM_ANCHORS[i];
                          if (!a) return;
                          const sel = state.selection[i];
                          if (!sel) return;
                          const color = sel.color || currentMetal || 'gold';
                          const inst = entry.scene.clone(true);
                          const isTexCharm = TEXTURE_GRAYSCALE_CHARMS.has(sel.handle);
                          console.log('[charm-nc]', 'handle=' + sel.handle, 'color=' + color, 'isTextureGrayscale=' + isTexCharm, 'goldenable=' + entry.goldenable);
                          if (isTexCharm) {
                            if (color === 'silver') applyGrayscaleMap(inst, sel.handle);
                          } else if (entry.goldenable) {
                            colorCharm(inst, color);
                          }
                          const box = new THREE.Box3().setFromObject(inst);
                          const s = box.getSize(new THREE.Vector3());
                          const c = box.getCenter(new THREE.Vector3());
                          inst.position.sub(c);
                          inst.scale.setScalar(CHARM_SIZE / Math.max(s.x, s.y, s.z));
                          const perCharmYaw = (CHARM_Y_ROTATION[sel.handle] ?? CHARM_Y_ROTATION_DEFAULT) - CHARM_Y_ROTATION_DEFAULT;
                          inst.rotation.y = perCharmYaw;
                          const wrap = new THREE.Group();
                          wrap.add(inst);
                          wrap.position.set(a.x, a.y, a.z);
                          wrap.rotation.y = (typeof self._ncFaceYaw === 'number') ? self._ncFaceYaw : CHARM_FACE_YAW;
                          charmGroup.add(wrap);
                        });
                        if (ANCHOR_DEBUG) drawAnchorMarkers();
                      }

                      // --- Debug overlay: visualize anchors as numbered V shape ---
                      let _debugGroup = null;
                      function drawAnchorMarkers() {
                        if (!chainModel) return;
                        if (_debugGroup) { chainModel.remove(_debugGroup); _debugGroup.traverse(o => { if (o.geometry) o.geometry.dispose(); if (o.material) o.material.dispose && o.material.dispose(); }); }
                        _debugGroup = new THREE.Group();
                        const scaleInv = 1 / (chainModel.scale.x || 1);
                        const sphereGeo = new THREE.SphereGeometry(0.18, 16, 16);
                        function lbl(txt) {
                          const c = document.createElement('canvas'); c.width = 64; c.height = 64;
                          const ctx = c.getContext('2d');
                          ctx.fillStyle = 'rgba(0,0,0,0.75)'; ctx.beginPath(); ctx.arc(32,32,28,0,Math.PI*2); ctx.fill();
                          ctx.fillStyle = '#fff'; ctx.font = 'bold 30px sans-serif';
                          ctx.textAlign='center'; ctx.textBaseline='middle'; ctx.fillText(txt, 32, 34);
                          const tex = new THREE.CanvasTexture(c); tex.colorSpace = THREE.SRGBColorSpace;
                          const sp = new THREE.Sprite(new THREE.SpriteMaterial({ map: tex, depthTest: false, transparent: true }));
                          sp.scale.set(0.6, 0.6, 1); sp.position.y = 0.45; sp.renderOrder = 1001;
                          return sp;
                        }
                        CHARM_ANCHORS.forEach((a, i) => {
                          const left = i < 5;
                          const m = new THREE.Mesh(sphereGeo, new THREE.MeshBasicMaterial({ color: left ? 0xff3355 : 0x33aaff, depthTest: false, transparent: true, opacity: 0.92 }));
                          m.renderOrder = 1000;
                          m.position.set(a.x, a.y, a.z);
                          m.add(lbl(String(i + 1)));
                          _debugGroup.add(m);
                        });
                        // V-arm guide lines
                        function lineFromAnchors(idxs, color) {
                          const pts = idxs.map(i => new THREE.Vector3(CHARM_ANCHORS[i].x, CHARM_ANCHORS[i].y, CHARM_ANCHORS[i].z));
                          const g = new THREE.BufferGeometry().setFromPoints(pts);
                          const mat = new THREE.LineDashedMaterial({ color, dashSize: 0.25, gapSize: 0.15, depthTest: false });
                          const l = new THREE.Line(g, mat); l.computeLineDistances(); l.renderOrder = 999;
                          return l;
                        }
                        _debugGroup.add(lineFromAnchors([4,3,2,1,0], 0xff3355));   // left arm inner→outer
                        _debugGroup.add(lineFromAnchors([5,6,7,8,9], 0x33aaff));   // right arm
                        _debugGroup.rotation.y = (typeof self._ncGroupYaw === 'number') ? self._ncGroupYaw : CHARM_GROUP_YAW_DEFAULT;
                        chainModel.add(_debugGroup);
                        printAnchorReadout();
                      }
                      function printAnchorReadout() {
                        const rows = CHARM_ANCHORS.map((a, i) => '  ' + String(i + 1).padStart(2) + ' (' + (i < 5 ? 'L' : 'R') + '): x=' + a.x.toFixed(2) + '  y=' + a.y.toFixed(2) + '  z=' + a.z.toFixed(2));
                        console.log('%c[nc-anchor] V-layout charm anchors (chain LOCAL space):\n' + rows.join('\n'),
                          'background:#222;color:#9fe;padding:4px;border-radius:4px;');
                      }

                      // V-shape tuner HUD — adjust cx/cy/dx/dy/z + face-yaw, regenerate anchors live
                      function initVTuner() {
                        const params = { cx: 3.7, cy: 1.85, dx: 0.45, dy: 0.7, x: 0.4, z: -1.5, yaw: CHARM_FACE_YAW, gYaw: CHARM_GROUP_YAW_DEFAULT };
                        const viewerEl = canvas.parentElement;
                        if (getComputedStyle(viewerEl).position === 'static') viewerEl.style.position = 'relative';
                        const panel = document.createElement('div');
                        panel.style.cssText = 'position:absolute;top:8px;right:8px;background:rgba(20,20,20,0.9);color:#fff;font:12px/1.3 system-ui,sans-serif;padding:10px;border-radius:6px;z-index:20;display:flex;flex-direction:column;gap:6px;width:230px;box-shadow:0 2px 8px rgba(0,0,0,0.4);';
                        function row(key, min, max, step) {
                          return '<label style="display:flex;align-items:center;gap:6px;">'
                            + '<span style="width:38px;">' + key + '</span>'
                            + '<input data-r="' + key + '" type="range" min="' + min + '" max="' + max + '" step="' + step + '" value="' + params[key] + '" style="flex:1;">'
                            + '<input data-rn="' + key + '" type="number" step="' + step + '" value="' + params[key] + '" style="width:60px;background:#222;color:#fff;border:1px solid #444;padding:2px;">'
                            + '</label>';
                        }
                        panel.innerHTML =
                          '<div style="font-weight:600;">V-layout tuner</div>'
                          + row('cx', 0, 10, 0.05)
                          + row('cy', -2, 6, 0.05)
                          + row('dx', 0, 4, 0.05)
                          + row('dy', -1, 3, 0.05)
                          + row('x',  -5, 5, 0.05)
                          + row('z',  -3, 5, 0.05)
                          + row('yaw', -Math.PI, Math.PI, 0.01)
                          + row('gYaw', -Math.PI, Math.PI, 0.01)
                          + '<div style="display:flex;gap:4px;">'
                          + '  <button data-r="dump" type="button" style="flex:1;padding:4px;background:#2a5;border:0;color:#fff;border-radius:3px;cursor:pointer;">Log JSON</button>'
                          + '  <button data-r="copy" type="button" style="flex:1;padding:4px;background:#25a;border:0;color:#fff;border-radius:3px;cursor:pointer;">Copy</button>'
                          + '</div>'
                          + '<div style="font-size:10px;opacity:0.65;">Left arm=red, right=blue. Yaw rotates each charm group.</div>';
                        viewerEl.appendChild(panel);

                        function regen() {
                          CHARM_ANCHORS.length = 0;
                          for (let i = 0; i < 5; i++) CHARM_ANCHORS.push({ x: params.x - (params.cx + params.dx * i), y: params.cy + params.dy * i, z: params.z });
                          for (let i = 0; i < 5; i++) CHARM_ANCHORS.push({ x: params.x + (params.cx + params.dx * i), y: params.cy + params.dy * i, z: params.z });
                        }
                        function applyAll() {
                          regen();
                          // patch face-yaw global without reassigning const
                          self._ncFaceYaw = params.yaw;
                          self._ncGroupYaw = params.gYaw;
                          if (charmGroup) charmGroup.rotation.y = params.gYaw;
                          if (_debugGroup) _debugGroup.rotation.y = params.gYaw;
                          rebuildCharms();
                          drawAnchorMarkers();
                        }
                        ['cx','cy','dx','dy','x','z','yaw','gYaw'].forEach(k => {
                          const r = panel.querySelector('[data-r="' + k + '"]');
                          const n = panel.querySelector('[data-rn="' + k + '"]');
                          r.addEventListener('input', () => { params[k] = parseFloat(r.value); n.value = r.value; applyAll(); });
                          n.addEventListener('input', () => { params[k] = parseFloat(n.value); r.value = n.value; applyAll(); });
                        });
                        panel.querySelector('[data-r="dump"]').addEventListener('click', () => {
                          const json = JSON.stringify(CHARM_ANCHORS, null, 2);
                          console.log('%c[nc-anchor] CHARM_ANCHORS = ' + json, 'color:#9fe;');
                        });
                        panel.querySelector('[data-r="copy"]').addEventListener('click', () => {
                          const json = JSON.stringify(CHARM_ANCHORS, null, 2);
                          if (navigator.clipboard) navigator.clipboard.writeText(json).catch(() => {});
                        });
                      }

                      // --- Picker state ---
                      // Sparse fixed-size array. Slot index drives anchor position; user picks slot via dropdown.
                      const state = { selection: new Array(MAX_CHARMS).fill(null) };
                      let uidSeq = 0;
                      function slotLabel(i) { return (i < 5 ? 'L' : 'R') + (i < 5 ? i + 1 : i - 4); }
                      function filledCount() { return state.selection.reduce((n, s) => s ? n + 1 : n, 0); }
                      function addCharm(c) {
                        const empty = state.selection.indexOf(null);
                        if (empty === -1) return;
                        const defaultColor = (currentMetal === 'silver') ? 'silver' : 'gold';
                        state.selection[empty] = Object.assign({ uid: ++uidSeq, color: defaultColor }, c);
                        afterChange();
                      }
                      function removeAt(i) {
                        if (!state.selection[i]) return;
                        state.selection[i] = null;
                        afterChange();
                      }
                      function setColorAt(i, color) {
                        const item = state.selection[i];
                        if (!item || item.color === color) return;
                        item.color = color;
                        afterChange();
                      }
                      function swapSlots(from, to) {
                        if (from === to || from < 0 || to < 0 || from >= MAX_CHARMS || to >= MAX_CHARMS) return;
                        const a = state.selection[from];
                        const b = state.selection[to];
                        state.selection[from] = b;
                        state.selection[to] = a;
                        afterChange();
                      }
                      function afterChange() {
                        renderTray();
                        updateCounter();
                        updateGalleryDisabled();
                        updateTotal();
                        rebuildCharms();
                      }

                      function renderGallery() {
                        galleryEl.innerHTML = '';
                        if (!charms.length) {
                          galleryEl.innerHTML = '<p style="grid-column:1/-1;font-size:0.8rem;color:#888;padding:0.5rem;">No charms available.</p>';
                          return;
                        }
                        charms.forEach((c) => {
                          const t = document.createElement('button');
                          t.type = 'button';
                          t.className = 'charm-builder__tile';
                          t.innerHTML =
                            '<img class="charm-builder__tile-img" loading="lazy" src="' + (c.image || '') + '" alt="' + (c.title || '').replace(/"/g, '&quot;') + '">' +
                            '<span class="charm-builder__tile-name">' + (c.title || '') + '</span>' +
                            '<span class="charm-builder__tile-price">' + (c.price || '') + '</span>';
                          t.addEventListener('click', () => addCharm(c));
                          galleryEl.appendChild(t);
                        });
                      }
                      function updateGalleryDisabled() {
                        const full = filledCount() >= MAX_CHARMS;
                        galleryEl.querySelectorAll('.charm-builder__tile').forEach(b => { b.disabled = full; });
                      }
                      function updateCounter() {
                        const n = filledCount();
                        counterEl.textContent = n + '/' + MAX_CHARMS;
                        counterEl.dataset.full = n >= MAX_CHARMS ? 'true' : 'false';
                      }
                      function updateTotal() {
                        const cents = state.selection.reduce((a, s) => a + Number(s && s.priceCents || 0), 0);
                        totalEl.textContent = formatMoney(cents);
                      }

                      let dragFromIdx = -1;
                      function renderTray() {
                        trayEl.innerHTML = '';
                        if (filledCount() === 0) {
                          const li = document.createElement('li');
                          li.className = 'charm-builder__tray-empty';
                          li.textContent = 'Tap a charm below to add it. Use the slot dropdown to set its position.';
                          trayEl.appendChild(li);
                          return;
                        }
                        state.selection.forEach((item, i) => {
                          if (!item) return;
                          const li = document.createElement('li');
                          li.className = 'charm-builder__tray-item';
                          li.draggable = true;
                          li.dataset.index = String(i);
                          li.title = item.title + ' (' + (item.color === 'silver' ? 'Silver' : 'Gold') + ') – ' + slotLabel(i);
                          const col = item.color || 'gold';
                          const slotOptions = state.selection.map((other, j) => {
                            const isSelf = j === i;
                            const taken = other && !isSelf;
                            const suffix = isSelf ? '' : (taken ? ' (swap with ' + (other.title || 'charm').replace(/"/g, '&quot;') + ')' : ' (empty)');
                            return '<option value="' + j + '"' + (isSelf ? ' selected' : '') + '>' + slotLabel(j) + suffix + '</option>';
                          }).join('');
                          li.innerHTML =
                            '<img class="charm-builder__tray-img" src="' + (item.image || '') + '" alt="' + (item.title || '').replace(/"/g, '&quot;') + '">' +
                            '<select class="charm-builder__tray-slot" aria-label="Charm position">' + slotOptions + '</select>' +
                            '<div class="charm-builder__tray-swatches" role="group" aria-label="Charm color">' +
                              '<button type="button" class="charm-builder__swatch is-gold' + (col === 'gold' ? ' is-active' : '') + '" data-color="gold" aria-label="Gold" aria-pressed="' + (col === 'gold') + '"></button>' +
                              '<button type="button" class="charm-builder__swatch is-silver' + (col === 'silver' ? ' is-active' : '') + '" data-color="silver" aria-label="Silver" aria-pressed="' + (col === 'silver') + '"></button>' +
                            '</div>' +
                            '<button type="button" class="charm-builder__tray-remove" aria-label="Remove charm">&times;</button>';
                          const slotSel = li.querySelector('.charm-builder__tray-slot');
                          slotSel.addEventListener('change', (e) => { e.stopPropagation(); swapSlots(i, parseInt(e.target.value, 10)); });
                          slotSel.addEventListener('mousedown', (e) => e.stopPropagation());
                          slotSel.addEventListener('click', (e) => e.stopPropagation());
                          slotSel.addEventListener('dragstart', (e) => e.preventDefault());
                          li.querySelectorAll('.charm-builder__swatch').forEach((sw) => {
                            sw.addEventListener('click', (e) => { e.stopPropagation(); setColorAt(i, sw.dataset.color); });
                            sw.addEventListener('mousedown', (e) => e.stopPropagation());
                            sw.addEventListener('dragstart', (e) => e.preventDefault());
                          });
                          li.querySelector('.charm-builder__tray-remove').addEventListener('click', (e) => { e.stopPropagation(); removeAt(i); });
                          li.addEventListener('dragstart', (e) => {
                            dragFromIdx = i; li.classList.add('is-dragging');
                            if (e.dataTransfer) { e.dataTransfer.effectAllowed = 'move'; try { e.dataTransfer.setData('text/plain', String(i)); } catch (_) {} }
                          });
                          li.addEventListener('dragend', () => {
                            li.classList.remove('is-dragging');
                            trayEl.querySelectorAll('.is-over').forEach(n => n.classList.remove('is-over'));
                            dragFromIdx = -1;
                          });
                          li.addEventListener('dragover', (e) => { e.preventDefault(); if (e.dataTransfer) e.dataTransfer.dropEffect = 'move'; li.classList.add('is-over'); });
                          li.addEventListener('dragleave', () => li.classList.remove('is-over'));
                          li.addEventListener('drop', (e) => {
                            e.preventDefault(); li.classList.remove('is-over');
                            if (dragFromIdx >= 0) swapSlots(dragFromIdx, i);
                          });
                          trayEl.appendChild(li);
                        });
                      }

                      // --- Modal open/close ---
                      function measureCanvas() {
                        const viewer = canvas.parentElement;
                        const w = canvas.clientWidth
                          || (viewer && viewer.clientWidth)
                          || Math.min(360, window.innerWidth - 64);
                        return Math.max(w, 200);
                      }
                      function openModal() {
                        if (typeof modal.showModal === 'function') modal.showModal();
                        else modal.setAttribute('open', '');
                        // Two rAFs: first lets dialog enter top layer, second lets flex settle so canvas has real width.
                        requestAnimationFrame(() => requestAnimationFrame(() => {
                          initScene();
                          if (renderer) {
                            const w = measureCanvas();
                            renderer.setSize(w, w, false);
                            if (camera) { camera.aspect = 1; camera.updateProjectionMatrix(); }
                            renderer.render(scene, camera);
                          }
                        }));
                        renderGallery();
                        if (ANCHOR_DEBUG && charms.length && filledCount() === 0) {
                          // auto-fill 10 charms (cycle gallery) so V visible immediately
                          for (let i = 0; i < MAX_CHARMS; i++) state.selection[i] = Object.assign({ uid: ++uidSeq }, charms[i % charms.length]);
                        }
                        afterChange();
                        updateNameText();
                        // sync metal w/ current variant
                        const m = getCurrentMetal();
                        if (m) {
                          currentMetal = m.toLowerCase();
                          if (textMesh && silverMat && goldMat) textMesh.material = currentMetal === 'gold' ? goldMat : silverMat;
                          recolorChain(currentMetal);
                        }
                      }
                      function closeModal() {
                        if (typeof modal.close === 'function') modal.close();
                        else modal.removeAttribute('open');
                      }
                      triggerBtn.addEventListener('click', openModal);
                      modal.querySelectorAll('[data-nc-close]').forEach(b => b.addEventListener('click', closeModal));
                      modal.addEventListener('click', (e) => { if (e.target === modal) closeModal(); });
                      document.addEventListener('visibilitychange', () => {
                        if (document.hidden && rafId) { cancelAnimationFrame(rafId); rafId = null; }
                        else if (!document.hidden && inited && !rafId) {
                          (function tick(){ controls.update(); renderer.render(scene, camera); rafId = requestAnimationFrame(tick); })();
                        }
                      });

                      // --- Submit: chain + charms in one /cart/add.js call ---
                      submitBtn.addEventListener('click', async () => {
                        const variantId = getCurrentVariantId();
                        const name = (nameInput && nameInput.value || '').trim().slice(0, 9);
                        const metal = getCurrentMetal();
                        if (!variantId) return;
                        if (!name) { alert('Please enter a name before adding to cart.'); return; }

                        const bundleId = 'shn-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 6);
                        const items = [];
                        const charmsLayout = state.selection.map((s, i) => {
                          if (!s) return null;
                          const col = s.color === 'silver' ? 'Silver' : 'Gold';
                          return slotLabel(i) + ': ' + s.title + ' (' + col + ')';
                        }).filter(Boolean).join(' | ');
                        const chainProps = { 'Name': name };
                        if (metal) chainProps['Metal'] = metal;
                        if (charmsLayout) chainProps['Charms'] = charmsLayout;
                        chainProps['_bundle_id'] = bundleId;
                        chainProps['_bundle_role'] = 'chain';
                        items.push({ id: variantId, quantity: 1, properties: chainProps });

                        state.selection.forEach((s, i) => {
                          if (!s) return;
                          let vid = s.variantId;
                          if (Array.isArray(s.variants) && s.variants.length) {
                            const m = s.variants.find(v => v.color === (s.color || 'gold'));
                            if (m && m.id) vid = m.id;
                          }
                          if (!vid) return;
                          items.push({
                            id: vid,
                            quantity: 1,
                            properties: {
                              '_bundle_id': bundleId,
                              '_bundle_role': 'charm',
                              '_position': slotLabel(i),
                              '_pairedWith': name
                            }
                          });
                        });

                        function captureCharmScreenshot() {
                          try {
                            if (!renderer) return null;
                            renderer.render(scene, camera);
                            const src = renderer.domElement;
                            const off = document.createElement('canvas');
                            off.width = 200; off.height = 200;
                            off.getContext('2d').drawImage(src, 0, 0, 200, 200);
                            return off.toDataURL('image/jpeg', 0.45);
                          } catch (e) { return null; }
                        }

                        submitBtn.disabled = true;
                        submitBtn.textContent = 'Adding…';
                        try {
                          const res = await fetch('/cart/add.js', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                            body: JSON.stringify({ items })
                          });
                          if (!res.ok) {
                            const err = await res.json().catch(() => ({}));
                            throw new Error(err.description || ('HTTP ' + res.status));
                          }
                          const shot = captureCharmScreenshot();
                          if (shot || charmsLayout) {
                            const attrs = {};
                            if (shot) attrs['_charm_screenshot'] = shot;
                            if (charmsLayout) attrs['_charm_layout'] = charmsLayout;
                            try {
                              await fetch('/cart/update.js', {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify({ attributes: attrs })
                              });
                            } catch (_) {}
                          }
                          closeModal();
                          window.location.href = '/cart';
                        } catch (err) {
                          alert('Could not add to cart: ' + (err && err.message || err));
                          submitBtn.disabled = false;
                          submitBtn.textContent = 'Add chain + charms to cart';
                        }
                      });

                      // Update charm metal hint when variant changes
                      // Variant pickers sit outside the form; their change events bubble to
                      // document. Listen there (form listener would never fire).
                      const onVariantChange = () => {
                        const m = getCurrentMetal();
                        if (!m || !inited) return;
                        currentMetal = m.toLowerCase();
                        if (textMesh) textMesh.material = currentMetal === 'gold' ? goldMat : silverMat;
                        recolorChain(currentMetal);
                      };
                      document.addEventListener('change', onVariantChange);
                      document.addEventListener('variant:change', onVariantChange);
                      // Re-render name in modal if user types after open
                      if (nameInput) {
                        let t;
                        nameInput.addEventListener('keyup', () => {
                          clearTimeout(t);
                          t = setTimeout(() => { if (inited && pinyonFont) updateNameText(); }, 500);
                        });
                      }
                    })();
